import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { QuestionAnswering, Button } from '../../components';

import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogAction from '@material-ui/core/DialogActions';


class Exam extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timeLeft: 0,
    };

    this.setTimer();
  }

  componentDidMount() {
    if (!this.props.exam || !this.props.exam.test) {
      if (this.props.match.params.testId) {
        this.props.loadExams({ id: this.props.match.params.testId });
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  setTimer = () => {
    this.timer = setInterval(() => {
      if (!this.props.testRun || !this.props.selectedExam) return null;
      const durationInSeconds = this.props.selectedExam.duration * 60;
      const timeSpentInSeconds = moment().diff(this.props.testRun.startDate, 'seconds');
      const difference = durationInSeconds - timeSpentInSeconds;
      let minutesLeft = difference / 60;
      let secondsLeft = difference % 60;
      if (difference < 0) {
        minutesLeft = 0;
        secondsLeft = 0;
        this.setState({ examEndedDialogOpen: true });
      }

      this.setState({ timeLeft: `${Math.floor(minutesLeft)} Minuten, ${secondsLeft} Sekunden` });
    }, 1000);
  }

  renderExamEndedDialog = () => (
    <Dialog open={this.state.examEndedDialogOpen}>
      <DialogTitle>
        <Typography>Zeit abgelaufen</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>Die Zeit für die Prüfung ist abgelaufen.
                        Ihr aktueller Fortschritt wird gespeichert und die Prüfung wird abgeschlossen.
                    </Typography>
      </DialogContent>
      <DialogAction>
        <Button
          label="Zurück zur Übersicht"
          color="primary"
          onClick={() => this.props.history.push('/exams')}
        />
      </DialogAction>
    </Dialog>
        )

  componentWillReceiveProps(nextProps) {
    if (!this.state.progress && nextProps.questions) {
      this.setState({
        progress: 1 / nextProps.questions.length,
      });
    }

    if (nextProps.testRun &&
            nextProps.testRun !== this.props.testRun) {
      this.props.loadTest({ id: this.props.match.params.testId });
    }

    if (nextProps.testRuns &&
            nextProps.testRuns !== this.props.testRuns &&
            !this.props.test &&
            this.props.match.params.testId) {
      this.props.loadTest({ id: this.props.match.params.testId });
    }
  }

  renderExamInformation = () => (
    <ExpansionPanel defaultExpanded>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography>Zeit verbleibend</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Typography>
                        Es verbleiben noch
                        <span style={{ fontWeight: 'bold' }}> {this.state.timeLeft} </span>
        </Typography>
      </ExpansionPanelDetails>
    </ExpansionPanel>
        )

  render() {
    const { selectedExam } = this.props;

    if (!selectedExam) return null;

    return (
      <div>
        <QuestionAnswering
          questions={this.props.questions}
          completed={this.props.completed}
          onRestart={this.props.onRestart}
          onLoadCard={this.props.onLoadCard}
          onCloseLinkedCard={this.props.onCloseLinkedCard}
          testRun={this.props.testRun}
          onSubmitAnswer={this.props.onSubmitAnswer}
          onSubmitTest={this.props.onSubmitTest}
          test={this.props.selectedExam.test}
          tests={this.props.tests}
          isLoading={this.props.isLoading}
          sideBarContent={this.renderExamInformation()}
          hideSideBarButtons
          card={this.props.card}
          location={this.props.location}
                    // exportView={queryString.parse(this.props.location.search).exportView}
          onOpenResult={() => this.props.history.push('/results')}
          onOpenTests={() => this.props.history.push('/tests')}
        />
        {this.renderExamEndedDialog()}
      </div>
    );
  }
}

Exam.propTypes = {
  questions: PropTypes.array,
  completed: PropTypes.bool,
  onRestart: PropTypes.func,
  onLoadCard: PropTypes.func,
  onCloseLinkedCard: PropTypes.func,
  testRun: PropTypes.object,
  onSubmitAnswer: PropTypes.func,
  onSubmitTest: PropTypes.func,
  test: PropTypes.object,
  tests: PropTypes.array,
  isLoading: PropTypes.bool,
  card: PropTypes.object,
  location: PropTypes.any,
  history: PropTypes.any,
  match: PropTypes.any,
  loadTest: PropTypes.func,
  loadResult: PropTypes.func,
};

Exam.defaultProps = {
  testRun: null,
  test: null,
  card: null,
  location: null,
  match: null,
  history: null,
  isLoading: false,
  completed: false,
  tests: [],
  questions: [],
  onRestart: () => { },
  onLoadCard: () => { },
  onCloseLinkedCard: () => { },
  onSubmitAnswer: () => { },
  onSubmitTest: () => { },
  loadTest: () => { },
  loadResult: () => { },
};

export default Exam;



// WEBPACK FOOTER //
// ./src/app/main/test/exam.js